// extracted by mini-css-extract-plugin
module.exports = {"block":"_15250","item":"_15622"};